module.exports = __webpack_public_path__ + "img/general.c3b1a5e0.svg";